import { useMemo } from 'react';

import { useNavigate } from 'react-router-dom';

import { useRecoil } from '@hooks/useRecoil';

import { TOTAL_NAV_ITEM_LIST } from '@components/header/HeaderWrapper';
import { PageTitle } from '@components/title/PageTitle';

import { CSSVariables } from '@utils/tailwind';

export const FMainPage = () => {
  const { useRecoilState, useAtom } = useRecoil();
  const [profile, setProfile] = useRecoilState(
    useAtom<{ uid: number; role: 'partner' | 'funeral'; name: string } | null>(
      'USER_PROFILE',
    ),
  );

  const menuItemList = useMemo(() => {
    return TOTAL_NAV_ITEM_LIST['funeral']
      .map((item) => ({
        title: item.title,
        link: item.link,
        id: item.link?.replace('/', '-'),
      }))
      .filter((item) => item.id != 'funeral-main');
  }, []);

  const CSSVariableStyle = useMemo(
    () =>
      CSSVariables({
        'effect-color': '#b0b0b0',
      }),
    [],
  );

  const navigate = useNavigate();

  return (
    <div className='container'>
      <PageTitle className='mt-4' titleHidden />
      <h1 className='text-3xl font-bold leading-[170%] tracking-tight'>
        환영합니다
        <br />
        <span className='pr-1 font-black tracking-tighter text-[#9e1e1e]'>
          {profile && profile.name}
        </span>
        님
        <br />
        방문해주셔서 감사합니다
      </h1>
      <section
        style={CSSVariableStyle}
        className='mt-4 grid grid-cols-2 gap-4 py-6'
      >
        {menuItemList.length != 0 &&
          menuItemList.map((item) => (
            <div
              key={item.id}
              className='effect-ripple rounded-md bg-gray-200 p-4 py-8'
              onClick={() => navigate(`/${item.link}`)}
            >
              <h3 className='text-lg font-semibold'>{item.title}</h3>
            </div>
          ))}
      </section>
    </div>
  );
};
